$.fn.loadDatepicker = function(){
    var isIE = document.all && !window.atob;

    if(isIE) return;

    var $datepicker = $(this),
        $lang = $("html").attr("lang"),
        $blocked_dates = $datepicker.data("blocked");

    var disabledDays = [0, 6];
    $.getScript("https://cdnjs.cloudflare.com/ajax/libs/air-datepicker/2.2.3/js/i18n/datepicker." + $lang + ".min.js").done(function () {
        $datepicker.datepicker({
            language: $lang,
            minDate: new Date(),
            prevHtml: '<i class="icon icon--arrow-left"></i>',
            nextHtml: '<i class="icon icon--arrow-right"></i>',
            minView: "days",
            onRenderCell: function (date, cellType) {
                if (cellType == 'day') {
                    var day = date.getDay(),
                        fullDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000).toISOString().substr(0, 10),
                        isDisabled = disabledDays.indexOf(day) != -1 || $blocked_dates.indexOf(fullDate) != -1;

                    return {
                        disabled: isDisabled
                    }
                }
            },
            onSelect: function (formattedDate, date, inst) {

                $('[data-error-notice="service_type"]').hide();

                var link = $datepicker.parent().find("[data-dialog-original]");
                var linkToClick = $datepicker.parent().find("[data-dialog]");

                var url = link.data("dialog-original");
                var fullDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000).toISOString().substr(0, 10);

                var serviceTypeValue = '';
                var serviceTypeSelect = $('[data-service-type-select]');

                if(serviceTypeSelect.length) {
                    serviceTypeValue = serviceTypeSelect.val();
                    if(!serviceTypeValue || !serviceTypeValue.length) {
                        $('[data-error-notice="service_type"]').show();
                        return;
                    }
                }

                var motoModelValue = '';
                var motoModelSelect = $('[data-moto-model-select]');

                if(motoModelSelect.length) {
                    motoModelValue = motoModelSelect.val();
                    if(!motoModelValue || !motoModelValue.length) {
                        $('[data-error-notice="moto_model"]').show();
                        return;
                    }
                }

                url = url.substr(0, url.lastIndexOf("d=")) + "d=" + fullDate + "&serviceTypeId=" + serviceTypeValue + "&motoModelId=" + motoModelValue;
                linkToClick.attr("data-dialog", url).data("dialog", url).click();
            }
        }).data('datepicker')
    });
};
